import { createContext } from 'react';
import type { UserAddressSchema } from './schema';
import type { UseFormReturn } from 'react-hook-form';
import type { Coordinates } from '@/modules/location/components/ui/map';

export type AddressViews =
  | 'select-delivery-address'
  | 'save-pined-address'
  | 'pin-map-address'
  | 'first';

export type UserAddressDrawerContextProps = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  navigate: (view: AddressViews) => void;
  goBack: () => void;
  handleBack: () => void;
  currentView: Exclude<AddressViews, 'first'>;
  formMethods: UseFormReturn<UserAddressSchema>;
  selectedMapPosition: Coordinates | null;
  setSelectedMapPosition: (position: Coordinates | null) => void;
  isEditing: boolean;
  isManualEntry: boolean;
  setIsManualEntry: (value: boolean) => void;
};

export const UserAddressDrawerContext = createContext<UserAddressDrawerContextProps>(
  {} as UserAddressDrawerContextProps
);
